import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
export let EChecklistStatus;
(function (EChecklistStatus) {
  EChecklistStatus["Pending"] = "pending";
  EChecklistStatus["Sent"] = "sent";
  EChecklistStatus["InProgress"] = "in-progress";
  EChecklistStatus["Completed"] = "completed";
})(EChecklistStatus || (EChecklistStatus = {}));
export let EChecklistItemStatus;
(function (EChecklistItemStatus) {
  EChecklistItemStatus["NotReady"] = "not-ready";
  EChecklistItemStatus["Pending"] = "pending";
  EChecklistItemStatus["InProgress"] = "in-progress";
  EChecklistItemStatus["Skipped"] = "skipped";
  EChecklistItemStatus["Completed"] = "completed";
})(EChecklistItemStatus || (EChecklistItemStatus = {}));
export let EChecklistItemRef;
(function (EChecklistItemRef) {
  EChecklistItemRef["PatientForm"] = "patient-form";
  EChecklistItemRef["Insurance"] = "insurance";
  EChecklistItemRef["Payment"] = "payment";
})(EChecklistItemRef || (EChecklistItemRef = {}));
export let EChecklistItemCategory;
(function (EChecklistItemCategory) {
  EChecklistItemCategory["Intake"] = "intake";
  EChecklistItemCategory["Demographics"] = "demographics";
  EChecklistItemCategory["Consent"] = "consent";
  EChecklistItemCategory["Insurance"] = "insurance";
  EChecklistItemCategory["Payment"] = "payment";
})(EChecklistItemCategory || (EChecklistItemCategory = {}));
export let EChecklistSource;
(function (EChecklistSource) {
  EChecklistSource["Appointment"] = "appointment";
  EChecklistSource["Message"] = "message";
  EChecklistSource["Manual"] = "manual";
})(EChecklistSource || (EChecklistSource = {}));
export const fieldsChecklistAppointmentV2 = _extends({}, fieldsIBaseModel, {
  appointment: {
    type: 'Text'
  },
  completedAt: {
    type: 'Date'
  },
  items: {
    type: 'Object',
    array: true
  },
  name: {
    type: 'Text'
  },
  patient: {
    type: 'Text'
  },
  source: {
    type: 'Option',
    values: EChecklistSource
  },
  status: {
    type: 'Option',
    values: EChecklistStatus
  },
  template: {
    type: 'Text'
  }
});